import { ChangeEvent } from 'react'
import { toast } from 'react-toastify'
import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { updateSxpState } from '../../utils/api'
import { CHAT_PROJECT_ID } from '../../utils/constants'
import KeycloakService from '../../utils/keycloakService'
import { LOCATION_SWITCH } from '../../utils/roles'
import {
  selectLocations,
  selectSelectedLocationId,
  selectLocationById,
  setSelectedLocation,
  getLocationData,
} from './locationSlice'
import { formValues, TYPE_STRING } from '../administration/constants'
import { switchLoc } from '../lms/constants'

const Location = () => {
  const locations = useAppSelector(selectLocations)
  const selectedId = useAppSelector(selectSelectedLocationId)
  const selectedLocation = useAppSelector((state) =>
    selectLocationById(selectedId, state)
  )
  let userLocations = KeycloakService?.getLocation()
  const hasRole = KeycloakService?.hasRole([LOCATION_SWITCH])
  const dispatch = useAppDispatch()
  const handleLocationChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const id = e.target.value
    const location = locations?.find((loc) => loc?.resource?.id === id)
    if (location) {
      dispatch(setSelectedLocation(id))
      const locData = getLocationData(location)
      const state = {
        selectedLocationId: id,
        locationValue: locData?.value,
        locationPrefix: locData?.prefix,
        selectedLocationName: locData?.name,
      }
      updateSxpState(CHAT_PROJECT_ID, state)?.then(() => {
        toast(`${switchLoc} ${locData.name}`, {
          position: 'bottom-center',
          hideProgressBar: true,
          closeButton: false,
          theme: 'dark',
          autoClose: 3000,
        })
      })
    }
  }
  if (typeof userLocations === TYPE_STRING) {
    userLocations = userLocations?.split(',')?.map((id: any) => id?.trim())
  }
  const hasUserLocations =
    Array?.isArray(userLocations) && userLocations?.length > 0
  const firstActiveLocation = locations?.find(
    (l) => l?.resource?.status === formValues?.active
  )
  let filteredLocations = []
  switch (true) {
    case hasRole:
      filteredLocations = locations?.filter(
        (l) => l?.resource?.status === formValues?.active
      )
      break
    case !hasUserLocations:
      return <span>{firstActiveLocation?.resource?.name ?? ''}</span>
    case userLocations?.length > 1:
      filteredLocations = locations?.filter(
        (l) =>
          l?.resource?.status === formValues?.active &&
          userLocations?.includes(String(l?.resource?.id))
      )
      break
    default:
      return (
        <span>{selectedLocation?.resource?.name ?? userLocations?.[0]}</span>
      )
  }

  return (
    <select
      onChange={handleLocationChange}
      value={
        selectedId ||
        (filteredLocations?.length ? filteredLocations?.[0]?.resource?.id : '')
      }
      className='locationDataSize'
    >
      {filteredLocations?.map((d) => (
        <option key={d?.resource?.id} value={d?.resource?.id}>
          {d?.resource?.name}
        </option>
      ))}
    </select>
  )
}

export default Location
